import { useState, useEffect, useRef } from 'react';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.offsetTop - 64, behavior: 'smooth' });
};

const ALL_COMMANDS = [
  { label: 'Home', hint: 'Navigate', icon: '⌂', action: () => scrollTo('home') },
  { label: 'Skills', hint: 'Navigate', icon: '⚡', action: () => scrollTo('skills') },
  { label: 'Experience', hint: 'Navigate', icon: '◈', action: () => scrollTo('experience') },
  { label: 'Resume', hint: 'Navigate', icon: '▤', action: () => scrollTo('resume') },
  { label: 'Projects', hint: 'Navigate', icon: '◻', action: () => scrollTo('projects') },
  { label: 'Contact', hint: 'Navigate', icon: '✉', action: () => scrollTo('contact') },
  { label: 'GitHub', hint: 'Open link', icon: '⎇', action: () => window.open('https://github.com/Emmm-07', '_blank') },
  { label: 'LinkedIn', hint: 'Open link', icon: '⋈', action: () => window.open('https://www.linkedin.com/in/john-michael-balatico-ba328530a/', '_blank') },
  {
    label: 'Download Resume', hint: 'File', icon: '⬇', action: () => {
      const a = document.createElement('a');
      a.href = '/resume.pdf';
      a.download = 'JM_Balatico_Resume.pdf';
      a.click();
    }
  },
];

const CommandPalette = ({ open, onClose }) => {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(0);
  const inputRef = useRef(null);

  const filtered = ALL_COMMANDS.filter(c =>
    c.label.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    if (open) {
      setQuery('');
      setSelected(0);
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [open]);

  useEffect(() => { setSelected(0); }, [query]);

  useEffect(() => {
    const handler = (e) => {
      if (!open) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setSelected(s => Math.min(s + 1, filtered.length - 1));
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setSelected(s => Math.max(s - 1, 0));
      }
      if (e.key === 'Enter' && filtered[selected]) {
        filtered[selected].action();
        onClose();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, filtered, selected, onClose]);

  if (!open) return null;

  return (
    <div className="cmd-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Command palette">
      <div className="cmd-modal" onClick={e => e.stopPropagation()}>
        <div className="cmd-header">
          <span className="cmd-icon">⌘</span>
          <input
            ref={inputRef}
            className="cmd-input"
            placeholder="Type a command or search..."
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <button className="cmd-esc" onClick={onClose}>esc</button>
        </div>
        <div className="cmd-list">
          {filtered.length === 0 && (
            <div className="cmd-empty">No results for "{query}"</div>
          )}
          {filtered.map((cmd, i) => (
            <button
              key={cmd.label}
              className={`cmd-item${i === selected ? ' active' : ''}`}
              onClick={() => { cmd.action(); onClose(); }}
              onMouseEnter={() => setSelected(i)}
            >
              <span className="cmd-item-icon">{cmd.icon}</span>
              <span className="cmd-item-label">{cmd.label}</span>
              <span className="cmd-item-hint">{cmd.hint}</span>
            </button>
          ))}
        </div>
        <div className="cmd-footer">
          <span>↑↓ navigate</span>
          <span>↵ select</span>
          <span>esc close</span>
        </div>
      </div>
    </div>
  );
};

export default CommandPalette;
